import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchBulkHistory, fetchBulkMembers } from './bulk-tools.action';
import { Observable } from 'rxjs';
import { selectBulkHistory } from './bulk-tools-selector';

@Injectable({ providedIn: 'root' })
export class BulkHistoryTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) {
        //Used Only If Multiselect Chcekbox Exist
        this.recordsList$ = this.store.select(selectBulkHistory);
    }
 
    pagination = [];
    filters = {
                created_at: '',
                action_id: null,
                notes: '',
                sending_to: '',
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    channels = [
        {id: "1", value: "BULK_TOOLS.email"},
        {id: "2", value: "BULK_TOOLS.whatsapp"},
        {id: "3", value: "BULK_TOOLS.sms"},
        {id: "4", value: "BULK_TOOLS.letter"},
    ];

    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'action_id', name: 'BULK_TOOLS.channel-type', sortable: true, hasFilter: true, filter: "select", options: 'channels', options_id: "id", options_label: "value"},
                { prop: 'notes', name: 'BULK_TOOLS.note', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'sending_to', name: 'BULK_TOOLS.sent-to', sortable: true, hasFilter: true, filter: "input"}
            ];

    recordsList$: Observable<any>; //Used Only If Multiselect Chcekbox Exist

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchBulkHistory());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        

    }

    resetState(){
        this.filters = {
            created_at: '',
            action_id: null,
            notes: '',
            sending_to: '',
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}